<template>
  <a @click="triggerAction">
    <slot v-if="!useIcon" name="trigger">
      <MButton>
        {{ $tc('approval') }}
      </MButton>
    </slot>
    <MIcon v-if="useIcon" name="eye" class="action-menu-icon" />
    <span v-if="useIcon">
      {{ `${$tc('view')} ${$tc('approval', 2)}` }}
    </span>
    <FlotoDrawer
      :open="showDrawer && kb.approvalStatus !== 'pre_approved'"
      width="65%"
      @hide="hideDrawer"
    >
      <template v-slot:title>
        {{ kb.name }}: {{ kb.subject }}
        <div>
          <small class="text-neutral">
            {{ kb.createdAt | datetime }}
          </small>
        </div>
      </template>
      <ApprovalContainer
        :module-name="moduleName"
        :resource-id="kb.id"
        :disabled="kb.status === 'expired'"
        @refresh-page="onRefreshPage"
      />
    </FlotoDrawer>
  </a>
</template>

<script>
import ApprovalContainer from '@components/approval/approval-container'
export default {
  name: 'ApprovalDetailsDrawer',
  components: {
    ApprovalContainer,
  },
  props: {
    kb: { type: Object, required: true },
    moduleName: { type: String, required: true },
    useIcon: { type: Boolean, default: false },
  },
  data: function () {
    return {
      showDrawer: false,
    }
  },
  methods: {
    triggerAction() {
      this.$emit('trigger')
      setTimeout(() => {
        this.showDrawer = true
      }, 400)
    },
    hideDrawer() {
      this.showDrawer = false
    },
    onRefreshPage() {
      this.hideDrawer()
      this.$emit('done')
    },
  },
}
</script>
